module.exports = __webpack_public_path__ + "static/media/gp.06c1d3fb.svg";